import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {SubSink} from '@Common/core/utils/subsink';
import {DepositService} from 'app/archivage/common/services/deposit/deposit.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Deposit, DepositState} from '../../common/services/deposit/deposit.model';
import { MatDialog } from '@angular/material/dialog';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import { HelperIndividuService } from 'app/archivage/common/services/helper-individu/helper-individu.service';
import {CommentComponentCallback} from '@Common/widgets/general/comments/comment/comment-callback.interface';
import {ApplicationEnum} from '@Common/widgets/general/attachments/interfaces/application.enum';
import {CommentModel} from '@Common/widgets/general/comments/interfaces/comment.model';
import {Observable} from 'rxjs';
import {environment} from '@Env/environment';
import {RouterExtService} from '@Services/base/router/router.service';
import {LocationService} from 'app/archivage/common/services/deposit/location.service';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-versement',
  templateUrl: './versement.html',
  styleUrls: ['./../../common/components/versement-consult.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VersementComponent implements OnInit, OnDestroy, CommentComponentCallback {
  subSink = new SubSink();
  deposit: Deposit;
  individu: Individu;
  isGestionnaire: boolean;
  depositState = DepositState;
  application: ApplicationEnum = ApplicationEnum.archivage;
  emails = [];
  /* gestion onglet dialogues */
  selectedTabIndex = 0;
  IDX_TAB_MESSAGE = 1;
  onMessage = null;
  loading = false;
  private _previousUrl;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pubSubSvc: PubSubService,
    private individuService: IndividuService,
    private helperIndividuService: HelperIndividuService,
    public depositSvc: DepositService,
    public dialog: MatDialog,
    private routerExtSvc: RouterExtService,
    public locationSvc: LocationService) {
  }

  ngOnInit(): void {
    this.onMessage = this.route.snapshot.params['message'];
    const depositId = this.route.snapshot.params['id'];
    this.subSink.sink = this.individuService.individu$.subscribe(individu => {
      this.isGestionnaire = this.helperIndividuService.isGestionnaire;
      this.individu = individu;
    });
    this._getDeposit(depositId);
    this._previousUrl = this.routerExtSvc.getPreviousUrl();
  }
  getSvcDepLabo() {
    if (this.deposit?.svc_dep_obj) {
      return this.deposit.svc_dep_obj.name;
    }
    if (this.deposit?.svc_autre) {
      return this.deposit.svc_autre;
    }
    return '/';
  }
  private _getDeposit(depositId: number): void {
    this.loading = true;
    this.subSink.sink = this.depositSvc
      .get(depositId)
      .pipe(finalize(() => this.loading = false))
      .subscribe((deposit: Deposit) => {
        this.deposit = deposit;
        this._setEmails([this.deposit.user_obj.email_pro, this.individu.email_pro]);
        this._goTabMessage();
    });
  }

  userInfo() {
    return `${this.deposit?.user_obj.last_name} ${this.deposit?.user_obj.first_name}`;
  }

  linearSize() {
    return `${this.deposit?.linear_size / 100} mètre(s) linéaire(s)`;
  }

  /**
   * Implémentations CommentComponentCallback : getLink & getTitle
   * @param comment
   * @param object_id
   */
  getLink(comment: CommentModel, object_id: number): Observable<string> {
    return new Observable(observer => {
      let urlToMessage = `/versement/consultation/${this.deposit.id}/messages`;
      if (environment.env !== 'dev') {
        urlToMessage = `/archivage${urlToMessage}`;
      }
      observer.next(urlToMessage);
      observer.complete();
    });
  }
  getLinkLabel(comment: CommentModel, object_id: number): Observable<string> {
    return new Observable(observer => {
      const linkLabel = 'Accéder aux messages';
      observer.next(linkLabel);
      observer.complete();
    });
  }
  getTitle(comment: CommentModel, object_id: number): Observable<string> {
    return new Observable(observer => {
      const title = `[ARCHIVAGE] Nouveau message sur la demande "${this.deposit?.deposit_identifier}"`;
      observer.next(title);
      observer.complete();
    });
  }

  private _setEmails(emails: string[]): void {
    this.emails.unshift(emails);
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  canEdit() {
    const editMode = this.route.snapshot?.data?.editMode || false;
    return editMode && this.isGestionnaire;
  }

  goBack() {
    if (this._previousUrl) {
      this.router.navigate([this._previousUrl]);
    } else {
      if (this.isGestionnaire) {
        this.router.navigate(['/gestion']);
      } else {
        this.router.navigate(['/versement']);
      }
    }
  }
  /**
   * Bascule sur l'onglet Messages
   * @private
   */
  private _goTabMessage() {
    if (this.onMessage) {
      this.selectedTabIndex = this.IDX_TAB_MESSAGE;
    }
  }
}
